export const helperProtocol = () => {
  if (window.location.protocol !== "https:") {
    window.location.replace(window.location.href.replace("http:", "https:"));
  }
};
